
import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate, Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import moment from "moment";
import * as Config from "../constants/Config";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import LocationSearch from "./LocationSearch";



let { lambda, country, appname } = window.app;

const SignUp = () => {
    const [pwd, setPwd] = useState('');
    const [email, setEmail] = useState("");
    const [formData, setFormData] = useState({ businessname: "", phone: "", emailId: "",logo:[ ],idc:"",contactname:"",businessaddress:"" });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [config, setConfig] = useState({});
    const navigate = useNavigate();
    const [subscriptionsData, setSubscriptionsData] = useState([]);
   
    const [image, setImg] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [showSessionPopup, setShowSessionPopup] = useState(false);
    const [BtnLoader, setBtnLoader] = useState(false);
    const GOOGLE_MAPS_API_KEY = "AIzaSyBFurzC88sUxAOb_cZ7hS9L3cgjk7SQB6E";

    const { userData, setUserData, activeMenuObj, setActiveMenuObj, GetUserDataContext, activeMenuId, setActiveMenuId,mapsAPIkey } = useContext(contentContext)
    const [address, setAddress] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    
    const [exist, setExist] = useState(false)
    const[sendEmail,setSendEmail]=useState(false)
    const[alertMsg,setAlertMsg]=useState(false)
    const [activeButtons, setActiveButtons] = useState({});
    const[verifyLoader,setVerifyLoader]=useState(false)
    const [countries, setCountries] = useState('');
    const [autocomplete, setAutocomplete] = useState(null);
    const inputRef = useRef(null); // Ref for the input element
    // console.log('google.maps.places',window.google.maps.places.Autocomplete); 

    // Ref for the search box
    // console.log('window.config',window?.site);
    const searchBoxRef = useRef(null);
    const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [selectedPlace, setSelectedPlace] = useState('');
    const [addressData, setAddressData] = useState({});
    const [filesData, setFilesData] = useState([]);
    const [files, setFiles] = useState([]);
   
  //  const [mapsAPIkey, setMapsAPIkey] = useState({});
    // const [idc, setIdc] = useState("US(+1)");
    console.log('selectedPlace',selectedPlace)
    console.log('addressData',addressData)
    // let siteConfig = window?.site?.common;
    // let appResourcesUrl = siteConfig?.imageCloudfront;

    // useEffect(() => {
    //     const defaultButtons = {};
    //     subscriptionsData.forEach((plan) => {
    //       defaultButtons[plan.planid] = 'Monthly';
    //     });
    //     setActiveButtons(defaultButtons);
    //   }, [subscriptionsData]);
    
    useEffect(() => {

        if (selectedPlace) {
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                ['businessaddress']: selectedPlace, // Update the changed field
            }));
        }
   
    
    }, [selectedPlace]);
  useEffect(() => {
    console.log("window.site---->",window.site);
    
    if (window?.site === undefined) {
        setTimeout(() => {
            if (window?.site?.common?.google?.mapsAPIkey) {
                
               // setMapsAPIkey(window?.site?.common?.google?.mapsAPIkey)
                // setImg(window.site.common.imagesCDN)
                console.log('window.site',window.site)
            }
        }, 1000);
    }
    if (window?.site?.common?.google?.mapsAPIkey) {
        //setMapsAPIkey(window?.site?.common?.google?.mapsAPIkey)
    }

}, [window.site]);

useEffect(() => {

    if (window.site === undefined) {
        setTimeout(() => {
            if (window.site && window.site.common && window.site.common.imageCloudfront) {
                setImg(window.site.common.imageCloudfront)
            }
        }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
        setImg(window.site.common.imageCloudfront)
    }


}, [window.site]);
useEffect(() => {
    if (toastMessage) {
      toast.warning(toastMessage, {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      // Clear the message after showing to prevent re-triggering
      setToastMessage("");
    }
  }, [toastMessage]);
  const handleAddressChange = (addressData) => {
    setFormData((prevState) => ({
        ...prevState,
        businessaddress: addressData?.fullAddress || "",
    }));

    setError((prevError) => ({
        ...prevError,
        businessaddress: "",
    }));
};
    const handleSelectPlan = (plan) => {
        const selectedPlanType = activeButtons[plan.planid];  // Get the active plan type for the selected plan

        const updatedSelectedPlan = {
          ...plan,
          planType: selectedPlanType  // Include the plan type in the selected plan object
        };
        setSelectedPlan(updatedSelectedPlan);
        console.log('selected plan', updatedSelectedPlan)
    };
   console.log('formdata',formData)
      // Initialize Google Places Autocomplete



      const getSbscriptionsApi = (e) => {
        axios({
            method: 'GET',
            url: `${lambda}/getSubscriptions?appname=${appname}`,
        })
        .then((response) => {
            if (response?.data?.result === "Invalid token or Expired") {
                // setShowSessionPopupup(true)
            } else {
                const data = response?.data?.result;

                if (data) {
                    // Setting the subscriptions data
                    setSubscriptionsData(data);
                
                    // Creating default buttons with 'Monthly' as default value
                    const defaultButtons = {};
                    data.forEach((plan) => {
                        defaultButtons[plan.planid] = 'Monthly';
                    });
                    setActiveButtons(defaultButtons);
                
               // Checking the status of all plans dynamically
const activePlans = data.filter(plan => plan.status === 'ACTIVE');
let selectedPlanData;

// Handle conditions based on active plans count
if (activePlans.length >= 3) {
    // If three or more plans are active, select the FIRST one
    selectedPlanData = activePlans[0];
} else if (activePlans.length === 2) {
    // If two plans are active, select the FIRST one
    selectedPlanData = activePlans[0];
} else if (activePlans.length === 1) {
    // If only one plan is active, select that plan
    selectedPlanData = activePlans[0];
} else {
    // If no plans are active, select the first plan by default
    selectedPlanData = data[0];
}

                
                    if (selectedPlanData) {
                        const selectedPlanType = defaultButtons[selectedPlanData.planid] || 'Monthly';
                
                        const updatedSelectedPlan = {
                            ...selectedPlanData,
                            planType: selectedPlanType
                        };
                
                        setSelectedPlan(updatedSelectedPlan);
                    }
                }
                
            }
        })
        .catch((err) => {
            console.log('Error:', err);
        });
    }
    

// console.log('sudata',subscriptionsData);


    // useEffect(() => {
    //     websitedefaults();
    // }, []);
    // const websitedefaults = async () => {
    //     try {
    //         console.log(tmdbApi);
    //         const response = await tmdbApi.websitedefaults();

    //         console.log(response);
    //     } catch {
    //         console.log("error");
    //     }
    // };
    // useEffect(() => {

    //     if (window.site === undefined) {
    //         setTimeout(() => {
    //             if (window.site && window.site.common && window.site.common.imagesCDN) {
    //                 setImg(window.site.common.imagesCDN)
    //             }
    //         }, 1000);
    //     }
    //     if (window.site && window.site.common && window.site.common.imagesCDN) {
    //         setImg(window.site.common.imagesCDN)
    //     }

    // }, [window.site]);

    //  useEffect(() => {
    //      if ((localStorage.getItem("userId"))) {
    //          GetUserDataSignIn();
    //      }
    //  }, []);

    useEffect(() => {
        if (localStorage.getItem("token")) {
            navigate("/dashboard");
        }
        getSbscriptionsApi();
        GetCountries()
    }, []);

    // const handleKeypress = (e) => {
    //     //it triggers by pressing the enter key

    //     if ((e.key === "Enter")) {
    //         setTimeout(function () {
    //             //  handleSignIn();
    //             console.log("called");
    //         }, 1000);
    //     }
    // };
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });

            const countries = response?.result?.data || [];
            setCountries(countries);
            const usaCountry = countries.filter(
                eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
            );

        // Print the filtered country in the console
        console.log("USA Country:", usaCountry);
        setFormData({...formData,idc:usaCountry?.[0]?.alpha3})
            // console.log('responseresponseresponse',response?.result.data)
            // await axios({
            //     method: 'GET',
            //     url: "https://d4nv8o5tzs3mt.cloudfront.net/",
            // })
            //     .then(function (response2) {
            //         console.log('response2',response2)
            //       // let locData = JSON.stringify(response?.data)
            //       let temp = response2.data.headers['cloudfront-viewer-country'][0].value
            //       console.log('temp',temp)
            //       setDefaultCountryCode(temp)

            //       let k = response && response?.result && response?.result.data && response?.result.data.length>0 && response?.result.data.filter(eachItem=>eachItem.alpha2.trim()===temp)

            //       if (id===undefined) {
            //         setIdc(k[0].alpha3)
            //         let newUser = Object.assign({}, editUser);
            //         setEditUser({ ...newUser, ['idc']: k[0].alpha3 });
            //       }



            //     });

        } catch {
            console.log("error");
        }
    };



    const handleSignUp = async (filesData) => {
       
        let logoImage = filesData?.[0]?.filepath;
        // console.log("ppan",selectedPlan)
        // let plan = selectedPlan.split(" ");
        // console.log("plan",plan)
        //  let planName = plan && plan[0] &&plan[0].toUpperCase();
         formData["subscription"] = selectedPlan?.planname
         formData["subscriptionPrice"] =  selectedPlan?.planType=="Monthly"? selectedPlan?.monthly : selectedPlan?.yearly
         formData["plantype"] = selectedPlan?.planType
         formData["planid"] = selectedPlan?.planid
         
         formData["businessaddress"] = addressData?.fullAddress
       
        try {

            const response = await tmdbApi.AddClient({
                ...formData,logo:filesData?.length>0?logoImage:""
            });
            console.log(response);
            if (response?.result === "Client Already Exists") {
                setBtnLoader(false)
                setToastMessage("Client Already Exists")
            //    AddNotify()

            }else if(response?.result==="PENDING VERIFICATION"){
                setBtnLoader(false)
               
                setSendEmail(true)
            }else if (response?.result==="PENDING APPROVAL"){
                setBtnLoader(false)
            //    setAlertMsg(true)
            navigate("/thankyou")
            }  else {
                setBtnLoader(false)
                navigate("/verifyaccount")
            }
        } catch {
            console.log("error");
            setBtnLoader(false)
            setError("Invalid email or password");
            setTimeout(function () { setError("") }, 3000);
        }
    };
    // console.log('userDatauserDatauserData', userData)
    const GetUserDataSignIn = async () => {
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions
                const EMAILID = response?.result?.[0]?.emailid
                console.log('user email', EMAILID)
                window.clarity("set", "orasi_user_email", EMAILID)
                // Clarity.addTag('Orasi User Email', EMAILID);
                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // console.log('objjjjjjjj--->',obj)

                if (!(localStorage.getItem("check"))) {
                    let k = response?.result?.[0]

                    let permissionList = response && response?.result && response?.result?.[0] && response?.result?.[0]?.permissions
                    let filterdList = permissionList.filter((item) => item.display===true)
                    const data = filterdList?.filter((value) => value?.menu === "Dashboard")
                    let id = data && data[0] && data[0].menu.split(" ").join("").toLowerCase()

                    navigate("/" + id);
                    navigate("/usermanagement");


                    setActiveMenuId(data && data[0] && data[0].menuid)
                    console.log("activeMenuid------->", data)
                }

                // setActiveMenuObj(obj)
                // setBtnLoader("")
                // console.log('response?.result?.[0] kkkkkkkkkk', response?.result?.[0])
            }
        } catch {
            // setBtnLoader("")
            console.log("error");
        }
    };
    // const AddNotify = () => {
    //     toast.warning(toastMessage, {
    //         position: "bottom-center",
    //       autoClose: 3000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   };
    // const forgotPassword = async () => {
    //     try {
    //         setBtnLoader("forgotpwd")
    //         const response = await tmdbApi.ForgotPassword({
    //             "emailid": email
    //         });
    //         console.log(response);
    //         if (response?.statusCode===200 && response?.result === "mail sent successfully") {
    //             setSuccess(true);
    //         } else if (response?.statusCode===200 && response?.result === "Email does not exists") {
    //             setError("Email Does Not Exists . Please Enter Valid Email");
    //             setTimeout(function () { setError("") }, 3000);
    //         } else {
    //             setError("Please Enter Email Id");
    //             setTimeout(function () { setError("") }, 3000);
    //         }
    //         setBtnLoader("")
    //     } catch {
    //         console.log("error");
    //         setBtnLoader("")
    //         setError("Please enter email id");
    //         setTimeout(function () { setError("") }, 3000);
    //     }
    // };


    // const handleForgot = (e) => {
    //     if (BtnLoader==="") {
    //         // forgotPassword();
    //     }
    // }

    // function onConfirm() {
    //     setSuccess(false);
    // };

    // const handleShowSessionPopup = () => {
    //     setShowSessionPopup(true)
    // }
    const onCancel = () => {
        setShowSessionPopup(false)
        // setBtnLoader("")
    }
    const signoutsession = async () => {
        try {
            // setBtnLoader("sessionLoad")
            const response = await tmdbApi.SignOutUser({ emailId: email });
            console.log(response);
            if (response?.result==="Success") {
                //  loginPwd()
            } else {
                setError("Invalid Details");
                // setBtnLoader("")
            }
        } catch {
            // setBtnLoader("")
            console.log("error");
        }
    }

    // const handleMessage = (e) => {
    //     setError("");
    // }


    const handleVerify = () => {
       
       
           
            handleUploadSubmit()

        

    }
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state
        
        setFormData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));
    
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
      
          if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = formData?.idc?.trim(); // Directly get the latest idc value

    if (currentIdc === "USA") {
        console.log("Using USA Format");
        if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
        if (numericValue.length > 6) {
            formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
        } else if (numericValue.length > 3) {
            formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
        } else {
            formattedValue = numericValue;
        }
    } else if (currentIdc === "IND") {
        console.log("Using India Format");
        if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
        if (numericValue.length > 5) {
            formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
        } else {
            formattedValue = numericValue;
        }
    }
    setError({ ...error, phone: "" })
    // Update the phone number only
    setFormData(prev => ({ ...prev, [name]: formattedValue }));

          } else if (name === "contactname") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, contactname: "" })

        }else if (name === "businessname") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, businessname: "" })

        } else if (name === "emailId") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, emailId: "" })

        } else {
            // Allow normal updates for other fields
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the changed field
            }));
        }
    };
    const handleSend = async () => {
        setVerifyLoader(true);
        try {
          const response = await tmdbApi.resendMail({
            emailId: formData?.emailId,
          });
          console.log(response);
          navigate("/verifyaccount");
          setSendEmail(false);
        } catch (error) {
          console.error("Error in handleSend:", error); // Logs the actual error
          setSendEmail(false);
        } finally {
          setVerifyLoader(false); // Ensure this is always reset
        }
      };
      
  const handleRemove = () => {
    // setUploadImg("")
    //setFormData("")
    setFilesData([])
    setFormData(prev => ({
        ...prev,
        logo: [] // Clear the logo array
    }));
}
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    // const selectedFilesSize = selectedFile.size; //for single file
    const selectedFiles = Array.from(event.target.files);  //for multiple files
    // const selectedFilesSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);  //for multiple files
    // console.log("selectedFile ", selectedFile)
    // console.log("selectedFiles ", selectedFiles)
    const allowedFileTypes = ["image/jpeg", "image/png", "image/heic"];
    let fileSize = 1048612 * 5 // 5MB
    if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
        setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
        event.target.value = null;
        return;
    }else 

    if (selectedFile.size < fileSize) {
            const previewUrl = URL.createObjectURL(selectedFile);
            setFormData(prev => ({
                ...prev,
                logo: [{ filepath: previewUrl }]
            }));
            setFilesData([selectedFile]); // Store file data
           
        } else {
            setToastMessage("File size should not exceed 5MB"); // Set the error message
            event.target.value = null;
    
        }
     
    


    // setFiles([...files, ...selectedFiles]); //for multiple files




};
const handleUploadSubmit = async () => {

    const ObjectID = require("bson-objectid");
    const uniqueId = new ObjectID().toString();
    // setLocationId(locationId)
const validate=handleValidations()
if(validate){
    setBtnLoader(true)
    localStorage.setItem("emailid", formData?.emailId);
    localStorage.setItem("phone", formData?.phone);
  
    if (filesData && filesData?.length > 0) {

        const uploadPromises = Array.from(filesData).map(async (file) => {
            const timestamp = Date.now();
            const fileExtension = file?.name?.split('.').pop();
            const clientid = localStorage.getItem('userId');
            const token = localStorage.getItem('token');
            const ObjectID = require("bson-objectid");

            const uniqueId = new ObjectID().toString();
            let uploadFilePath;
            let bucket;

            // Check the file type
            if (file.type.startsWith('image/')) {
                // File is an image
                let filenameReplace = file.name.replace(/ /g, "_")
                uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                const data = {
                    source_bucket: bucket, // Use the correct bucket based on file type
                    sourcepath: uploadFilePath
                };
                console.log("data", data)
                const newFile = [{
                    filename: filenameReplace.split('.')[0],
                    filepath: uploadFilePath,
                    fileid: uniqueId,
                    filetype: file.type,
                    filesize: file.size,
                    fileformat: fileExtension
                }]
                const updatedFiles = [...files, ...newFile];
                console.log("updatedFiles", updatedFiles)
                setFiles(updatedFiles);

                const uploadPromise = axios.post(
                    `${lambda}/uploadURL?appname=${appname}`,
                    data,
                    { headers: { 'Content-Type': 'application/json' } }
                ).then(async uploadUrlResponse => {
                    if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                        const url = uploadUrlResponse.data.result;

                        return axios.put(url, file, {
                            headers: {
                                'Content-Type': file.type,
                                'Cache-Control': 'no-cache'
                            }
                        }).then(async uploadResponse => {
                            if (uploadResponse.status === 200) {
                                // setFiles([...files, ...newFile]); 
                                // handleSubmit(updatedFiles);
                                handleSignUp(updatedFiles)
                            } else {
                                throw new Error('Failed to upload file to S3');
                            }
                        });
                    } else {
                        throw new Error('Failed to get upload URL');
                    }
                });


            }


        });

        try {
            //const results = await Promise.all(uploadPromises);
            await Promise.all(uploadPromises);

        } catch (error) {
            console.error('Error during file upload:', error);
        }
    } else {
        // handleSubmit([], uniqueId);
     
            handleSignUp([], uniqueId);
        
    }
}
   

}
console.log("selectedPlaannnnnnnnnnnnnnnnnnnn",selectedPlan)
const handleClose=()=>{
    setSendEmail(false)
}
    const handleValidations = () => {
        let formIsValid = true;
        if (formData?.businessname === "") {
            setError((prevData) => ({
                ...prevData,
                ["businessname"]: "Please enter Name",
            }));


            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["businessname"]: "",
            }));
        }
        if (formData?.contactname === "") {
            setError((prevData) => ({
                ...prevData,
                ["contactname"]: "Please enter contact name",
            }));


            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["contactname"]: "",
            }));
        }
        if (formData?.businessaddress === "") {
            setError((prevData) => ({
                ...prevData,
                ["businessaddress"]: "Please enter businessaddress",
            }));


            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["businessaddress"]: "",
            }));
        }
        if (formData?.phone === "") {
            setError((prevData) => ({
                ...prevData,
                ["phone"]: "Please enter phone number",
            }));


            formIsValid = false;
        }else if (
            (formData.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phone)) ||
            (formData.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(formData.phone))
        ) {
            setError((prevData) => ({
                ...prevData,
                ["phone"]: 'Invalid phone number format',
            }));
            
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["phone"]: "",
            }));
        }


        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (formData?.emailId === "") {
            setError((prevData) => ({
                ...prevData,
                ["emailId"]: "Please enter Email",
            }));

            formIsValid = false;
        } else if (!emailRegex.test(formData?.emailId)) {
            setError((prevData) => ({
                ...prevData,
                ["emailid"]: "Please enter a valid Email address",
            }));


            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["email"]: "",
            }));
        }

        return formIsValid;
    }
    const handlePlanClick = (planId, type) => {
        // Update the activeButtons state
        setActiveButtons(prev => ({
          ...prev,
          [planId]: type
        }));
      
        // Update the selectedPlan if the planId matches the current selectedPlan
        if (selectedPlan?.planid === planId) {
          setSelectedPlan(prevPlan => ({
            ...prevPlan,
            planType: type
          }));
        }
      };
      
    
  

    return (
        <>
            <Modal className="access-denied" show={showSessionPopup} >

                <div className="modal-body enquiry-form">
                    <div className="container">
                        <button className="close-btn" onClick={e => onCancel()}><span className="material-icons">close</span></button>
                        {/* <span className="material-icons access-denied-icon">https</span> */}
                        <span className="material-icons access-denied-icon">
                            web_asset_off
                        </span>
                        <h3>Multiple Sessions Found</h3>
                        <p>Another session is running in another browser. Do you want to terminate that session?</p>
                        <div className="popup-footer">
                            <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => signoutsession()}>{BtnLoader==="sessionLoad" ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />) : null}Yes</button>
                            <button className="fill_btn" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => onCancel()}>No</button>
                        </div>
                    </div>
                </div>

            </Modal>



            <div className="signin-wrapper registration" id="signin-wrapper">
  <div className="logo_section" id="logo-section">
    <img
      src={`${image}${appname}/images/web/logo-dark.png`}
      className="logo"
      id="logo"
    />
   <button className="close-btn" id="close-btn"  onClick={() => {
      window.location.href = 'https://d1fln26yclkehg.cloudfront.net/index.html';
    }}>
  <span
    className="material-icons"
   
    id="close-icon"
  >
    close
  </span>
</button>

  </div>
  <div className="card" id="create-client-card">
    <div className="card-body" id="create-client-card-body">
      <div className="create_client" id="create-client">
        <div className="d-flex flex-column" id="steps-title">
       
          <h1 className="bold-heading" id="create-client-title">Create Client</h1>
          <h5 id="create-client-subtitle">Let’s set up your Brand experience with these below steps</h5>
          <p className="signup-prompt mt-3 login-have-txt" id="defaultCreateAccountPrompt">
Already have an account?
              <a className="mx-2" style={{ cursor: 'pointer' }} onClick={() => { navigate('/signin') }} id="defaultCreateAccountLink">
              Login Here
              </a>
            </p>
        </div>

        {/* <div className="steps" id="steps">
          <p id="step-count"><span>1</span>/2</p>
          <div className="d-flex flex-row" id="step-buttons">
            <button className="step_btn active" id="active-step-btn"></button>
            <button className="step_btn" id="inactive-step-btn"></button>
          </div>
        </div> */}
      </div>
      <div className="select_plan" id="select-plan">
        <div className="icon" id="plan-icon">
          <img src={`${image}${appname}/images/web/cards.svg`} id="plan-img" />
        </div>
        <div className="text" id="plan-text">
          <h6 id="select-plan-title">Select Plan</h6>
          <p id="plan-description">Add all information about your Brand to your account</p>
        </div>
      </div>

      <div className="row plans" id="plans-row">
      {subscriptionsData.filter((plan) => plan.status === 'ACTIVE').map((plan) => (

        <div key={plan.planid} className="col-md-4" id={`plan-col-${plan.planid}`}>
          <div
            className={`basic_plan ${
              selectedPlan?.planname?.toLowerCase() === plan.planname?.toLowerCase() ? 'active_plan' : ''
            }`}
            id={`plan-${plan.planname?.toLowerCase()}`}
          >
            <h6 id={`plan-name-${plan.planname?.toLowerCase()}`}>{plan.planname}</h6>
            <p className="per_month" id={`plan-price-${plan.planname?.toLowerCase()}`}>
              <span>
                ${activeButtons[plan.planid] === 'Yearly' ? plan.yearly : plan.monthly}
              </span> /per {(activeButtons[plan.planid] || 'Monthly').toLowerCase()}
            </p>
            <p id={`plan-tagline-${plan.planname?.toLowerCase()}`}>{plan.tagline}</p>
            
            <div className="select_billing mb-3">
              <button
                 className={`yearly ${activeButtons[plan.planid] === 'Monthly' ? 'active' : ''}`}
                 onClick={() => handlePlanClick(plan.planid, 'Monthly')}
              >
                Monthly
              </button>

              <button
                className={`yearly ${activeButtons[plan.planid] === 'Yearly' ? 'active' : ''}`}
                onClick={() => handlePlanClick(plan.planid, 'Yearly')}
              >
                Yearly <span className="text-sm text-green-600 ml-2">save 10%</span>
              </button>
            </div>

            {/* <button
              className="fill-btn black_btn"
              onClick={() => handleSelectPlan(plan)}
              id={`plan-select-btn-${plan.planname?.toLowerCase()}`}
            >
              Select
            </button> */}

            <hr id={`plan-hr-${plan.planname?.toLowerCase()}`} />
            
            {plan.features.map((feature, index) => (
  feature.value && (
    <div key={index} className="points" id={`feature-${index}-${plan.planname?.toLowerCase()}`}>
   <span class="material-symbols-outlined check-icons">chevron_right</span>
      <p id={`feature-description-${index}-${plan.planname?.toLowerCase()}`}>
      {feature.label ? `${feature.value} ${feature.feature}${feature.value > 1 ? 's' : ''}` : feature.value}
      </p>
    </div>
  )
))}
<div className="Plan-select-footer">
<button className={`fill-btn ${selectedPlan?.planname?.toLowerCase() === plan.planname?.toLowerCase() ?"":"black_btn"}`}
              onClick={() => handleSelectPlan(plan)}
              id={`plan-select-btn-${plan.planname?.toLowerCase()}`}
            >
              Select
</button>
</div>
          </div>
        </div>
      ))}
      </div>
    </div>
  </div>

  <div className="card client_details client-details-errormssg" id="client-details-card">
    <div className="card-body" id="client-details-card-body">
      <div className="row" id="client-details-row">
        <div className="col-md-12 client-details-section error" id="client-details-col-1">
          <div className="select_plan" id="client-details-select-plan">
            <div className="icon" id="client-details-icon">
              <img
                src={`${image}${appname}/images/web/user-profile.svg`}
                id="client-profile-icon"
              />
            </div>
            <div className="text" id="client-details-text">
              <h6 id="client-details-title">Client Details</h6>
              <p id="client-details-description">Add all information about your Business to your account</p>
            </div>
          </div>

    <div className="row mb-2">
    <label className="form_label" for="html">Business Name</label>
    <div className="col-md-6">
    
    {/* bussiness name */}
    <div className="input-group mr-sm-2" id="business-name-group">
                <div className="input-group-prepend" id="business-name-prepend">
                  <div className="input-group-text" id="business-name-icon">
                    <span className="material-symbols-outlined">account_circle</span>
                  </div>
                </div>
                <input
                  type="text"
                  className="form-control"
                  name="businessname"
                  id="businessname-input"
                  placeholder="Business Name"
                  value={formData?.name}
                  onChange={handleChange}
                //   id="business-name-field"
                />
                {error && <span className="errormsg" id="businessname-error">{error?.businessname}</span>}
    </div>
    {/* bussiness name */}
    
    </div>
    <div className="col-md-6">
    {/* bussiness address */}
    <div className="input-group mb-3 mr-sm-2">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text"><span className="material-symbols-outlined">location_on</span></div>
                                        </div>
                                        {/* <input type="text" className="form-control" name="address" id="inlineFormInputGroupUsername2" value={formData?.address} onChange={handleChange} placeholder="Business Address" /> */}
    
                                        {mapsAPIkey!= false && <LocationSearch
                                            setSelectedPlace={(place) => {
                                                setSelectedPlace(place);
                                                handleAddressChange(addressData);
                                            }}
                                            setAddressData={(data) => {
                                                setAddressData(data);
                                                handleAddressChange(data);
                                            }}
                                           
                                            onBlur={() => handleAddressChange({ fullAddress: formData?.businessaddress })}
                                            selectedPlace={formData?.businessaddress}
                                            mapsAPIkey={mapsAPIkey}
                                        />}
                                        {error && <span className="errormsg" style={{
                                            fontWeight: 'bold',
                                            color: 'red',
                                        }}>{error?.businessaddress}</span>}
    </div>
    {/* bussiness address */}
    </div>
    </div>
    
    <div className="row">
    <label className="form_label" for="html">Contact Personal Info</label>
        <div className="col-md-6">
        {/* contact Name */}
        <div className="input-group mb-3 mr-sm-2" id="business-name-group">
                <div className="input-group-prepend" id="business-name-prepend">
                  <div className="input-group-text" id="business-name-icon">
                    <span className="material-symbols-outlined">account_circle</span>
                  </div>
                </div>
                <input
                  type="text"
                  className="form-control"
                  name="contactname"
                  id="businessname-input"
                  placeholder="Contact Name"
                  value={formData?.contactname}
                  onChange={handleChange}
                //   id="business-name-field"
                />
                {error && <span className="errormsg" id="businessname-error">{error?.contactname}</span>}
        </div>
        {/* contact Name */}
        </div>
        <div className="col-md-6">
            {/* phone number */}
            <div className="input-group mb-3 mr-sm-2">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text"><span className="material-symbols-outlined">call</span></div>
                                        </div>
                                        
                                        <select name="idc" className="colorselect capitalize" 
                                      onChange={handleCountryChange} value={formData?.idc}>
                                            {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                                                    return (
                                                                                        <><option key={i} value={task.alpha3}>{task.alpha3}{task.countrycode}</option></>
                                                                                    )
                                                                                }
                                                                                )}
                                        </select>
    
    
                                        <input type="text" className="form-control" name="phone" id="inlineFormInputGroupEmail" value={formData?.phone} onChange={handleChange} placeholder="Phone Number" />
                                        {error && <span className="errormsg" style={{
                                            fontWeight: 'bold',
                                            color: 'red',
                                        }}>{error?.phone}</span>}
            </div>
            {/* phone number */}
        </div>
        <div className="col-md-6">
            <div>
{/* contact email */}
                <div className="input-group mb-3 mr-sm-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><span className="material-symbols-outlined">mail</span></div>
                                    </div>
                                    <input type="text" className="form-control" name="emailId" id="inlineFormInputGroupPassword" value={formData?.emailId} onChange={handleChange} placeholder="Email" />
                                    {error && <span className="errormsg" style={{
                                        fontWeight: 'bold',
                                        color: 'red',
                                    }}>{error?.emailId}</span>}
                </div>

{/* contact email */}
            </div>
            <div>
            <label className="form_label mt-2" for="html">UPLOAD LOGO (optional)</label>
            <div className="upload-zone input-group mb-2 mr-sm-2">

{formData?.logo?.length > 0 ?
    <div className="upload-icon mt-1">
        <div className="img_block add_img_block">
            <span className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove}>close</span>

            <img
                src={
                  formData.logo[0].filepath  // Show blob preview URL
                       
                } id="activimg" />
            {/* <img id="activimg" src={uploadImg ? uploadImg : "assets/img/store-thumb-img.jpg"} width={150} /> */}
        </div>
    </div> :
    <>

        <div>

            <input
                type="file"
                id="file-upload"
                accept="image/jpeg, image/png,image/heic,image/jpg"
                className="d-none"
                multiple={false}
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />

            <label
                htmlFor="file-upload" className="stroke-button"
            >
                <span className="material-icons">file_upload</span>
            </label>
        </div>
        <div className="file_requirements ">
            <p>Maximum file size: 5MB</p>
            <p>Supported formats: JPG, PNG, HEIC</p>
        </div></>

}

{/* {errors.logo && <div className="error">{errors.logo}</div>} */}
</div>
            </div>
            <div>
            <button className="fill-btn save_continue mt-2" id="saveContinueBtn"  onClick={handleVerify}>{BtnLoader ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />) : null}Save & Continue</button>
            </div>
        </div>
        <div className="col-md-6">
        <img src={`${image}${appname}/images/web/client-details-img.svg`} className="client-login-img"/>
        </div>
    
    </div>
                            </div>

                        </div>
                        <SweetAlert show={exist}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Client Already Exists"}
                            onConfirm={e => setExist(false)}
                        />

    <Modal className="access-denied" show={sendEmail} >

<div className="modal-body enquiry-form">
    <div className="container">
        <button className="close-btn" id="close-button" onClick={e => handleClose()}><span className="material-icons">close</span></button>
        {/* <span className="material-icons access-denied-icon">https</span> */}
        <span className="material-icons access-denied-icon">
            web_asset_off
        </span>
        <h3>OTP Verification</h3>
        <p> Click here to receive the OTP and continue your verification.</p>
        <div className="popup-footer">
        <button 
        id="verify-button"
  className="fill-btn mt-3"
  type="button"
  onClick={(e) => {
    e.preventDefault(); 
    console.log("Button clicked, calling handleSend...");
    handleSend();
  }}
>
  {verifyLoader ? (
    <img 
      src={`${image}${appname}/images/web/rotate_right.svg`}
      className="loading-icon" 
      alt="Loading"
    />
  ) : null} Verify
</button>

          
        </div>
    </div>
</div>

</Modal>
                <SweetAlert show={alertMsg}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"Please Wait For Admin Approval"}
                    onConfirm={e => setAlertMsg(false)}

                />
               
                    </div>
                </div>
            </div>
            <footer className="login_footer">
                <div className="container-fluid">
                    <p className="footer-para">© 2026 SpotSaver. All rights reserved. </p>
                </div>
               
            </footer>
            <ToastContainer
      position="bottom-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover={false}
      theme="light"
      id="toastContainer"
    />
        </>
    );
};

export default SignUp;
